
export default {
  data () {
    return {
      data: [
        {
          id: 1,
          title: 'News',
          img: require('@/assets/img/home-footer-01.png'),
          url: '/news'
        },
        {
          id: 2,
          title: 'How to work with MDF',
          img: require('@/assets/img/home-footer-02.png'),
          url: '/work'
        }
      ]
    }
  },
  methods: {
    toPage (url) {
      this.$router.push(url)
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
}
